import AvailableProgramsTable from './AvailableProgramsTable';

export default AvailableProgramsTable;
